<div class="home-wrap">
  <app-header></app-header>
  <div class="home-section-wrap">
    <section class="flex-cont text-section mb-5">
      <h1>Speech Data Collection Platform</h1>
      <p class="accent-detail">
        Please donate your voice, our database currently have <span>{{totalRecording && totalRecording}}</span> samples and we need your unique voice to make it to <span>5000 🎉</span>
      </p>
      <br>
      <p class="get-started">Get started in two simple steps</p>
      <section class="icon-wrap">
        <div class="d-flex align-items-center w-100 mb-2">
          <img src="../../assets/svg/complete_svg.svg" class="mr-3" alt="complete form">
          <p class="font-weight-bold mb-0">Complete the form <span class="font-weight-normal"></span></p>
        </div>
        <div class="d-flex align-items-center w-100 ">
          <img src="../../assets/svg/start_svg.svg" class="mr-3" alt="complete form">
          <p class="font-weight-bold mb-0">Record displayed text</p>
        </div>
      </section>
      <a href="/learn_more" class="learn-more d-flex align-items-center justify-content-center"> Learn more</a>
    </section>
    <section class="flex-cont form-section justify-content-center">
      <div class="form-container" [formGroup]="application">
        <!-- Change this to radio button; Nigeria and others -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>nationality</mat-label>
          <mat-select [(value)]="nationalitySelected" (selectionChange)="onChangeNationality()" formControlName="nationality">
            <mat-option value="Nigerian">
              Nigerian
            </mat-option>
            <mat-option value="Others">
              Others
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" [hidden]="!otherNationality">
          <mat-label>please input your nationality</mat-label>
          <input matInput formControlName="otherNationalityInput">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>country of residence</mat-label>
          <mat-select [(value)]="countryResidentSelected" formControlName="countryResidence">
            <mat-option matSelect *ngFor="let item of countryResidentOptions" [value]="item.Country">
              {{item.Country}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>native language</mat-label>
          <mat-select [(value)]="nativeSelected" (selectionChange)="onChangeOtherLang()" formControlName="nativeLanguage">
            <mat-option matSelect *ngFor="let item of nativeLanguageOptions" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" [hidden]="!otherLanguage">
          <mat-label>please input native language</mat-label>
          <input matInput formControlName="otherNativeInput">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>other non-english spoken languages (select all that apply)</mat-label>
          <mat-select [(value)]="otherSelected" multiple (selectionChange)="onChangeSpokenLang()" formControlName="otherLanguages">
            <mat-option matSelect *ngFor="let item of otherLanguageOptions" [value]="item.languages">
              {{item.languages}}
            </mat-option>
            <mat-option matSelect value="None">
              None
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" [hidden]="!otherSpoken">
          <mat-label>please input other non-english spoken language</mat-label>
          <input matInput formControlName="otherSpokenInput">
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>kindly choose language that you think influences your english accent</mat-label>
          <mat-select [(value)]="fluentLangSelected" (selectionChange)="onChangeFluentLanguage()" formControlName="fluentLanguage">
            <mat-option matSelect *ngFor="let item of fluentLangOptions" [value]="item.languages">
              {{item.languages}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" [hidden]="!otherFluentLanguage">
          <mat-label>please input other language that you think influences your english accent</mat-label>
          <input matInput formControlName="otherFluentLanguageInput">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>at what age did you start speaking english</mat-label>
          <mat-select [(value)]="ageSelected" formControlName="ageOfEnglish">
            <mat-option matSelect *ngFor="let item of ageOfEnglishOptions" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button (click)="goToVoiceRecorder()" class="form-btn btn m-0">Get started</button>
      </div>
    </section>
  </div>
</div>

